module.exports = __webpack_public_path__ + "static/media/new-employer.aa2e862f.svg";